var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":_vm.right,"no-caret":_vm.noCaret}},[_c('template',{slot:"button-content"},[_vm._t("header",[_vm._v("\n      ❔\n    ")])],2),_vm._v(" "),_vm._t("dropdown",[_c('div',{style:({ right: 'auto', height: '200px' })},[_c('span',{staticClass:"text-center"},[_vm._v("dropdown")])])])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cc8df00","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdown.vue
// module id = null
// module chunks = 